var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47.9966,
    height: 36,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46.9966,
    height: 35,
    rx: 7.5,
    stroke: "#040517",
    strokeOpacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_591_2454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.175 18.2388V21.6562H22.05V13.2047H24.975C25.6875 13.2047 26.3625 13.4619 26.8875 13.9396C27.4125 14.3806 27.675 15.042 27.675 15.7401C27.675 16.4383 27.4125 17.063 26.8875 17.5407C26.3625 18.0184 25.725 18.2756 24.975 18.2756L23.175 18.2388ZM23.175 14.2336V17.1732H25.05C25.4625 17.1732 25.875 17.0262 26.1375 16.7323C26.7375 16.1811 26.7375 15.2625 26.175 14.7113L26.1375 14.6745C25.8375 14.3806 25.4625 14.1968 25.05 14.2336H23.175Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2625 15.7034C31.0875 15.7034 31.725 15.9239 32.2125 16.3648C32.7 16.8058 32.925 17.3937 32.925 18.1286V21.6562H31.875V20.8478H31.8375C31.3875 21.5092 30.75 21.8399 30 21.8399C29.3625 21.8399 28.8 21.6562 28.35 21.2887C27.9375 20.9212 27.675 20.4068 27.675 19.8556C27.675 19.2677 27.9 18.79 28.35 18.4226C28.8 18.0551 29.4375 17.9081 30.1875 17.9081C30.8625 17.9081 31.3875 18.0184 31.8 18.2756V18.0184C31.8 17.6509 31.65 17.2835 31.35 17.063C31.05 16.8058 30.675 16.6588 30.2625 16.6588C29.625 16.6588 29.1375 16.916 28.8 17.4304L27.825 16.8425C28.425 16.0709 29.2125 15.7034 30.2625 15.7034ZM28.8375 19.8924C28.8375 20.1863 28.9875 20.4436 29.2125 20.5905C29.475 20.7743 29.775 20.8845 30.075 20.8845C30.525 20.8845 30.975 20.7008 31.3125 20.3701C31.6875 20.0394 31.875 19.6352 31.875 19.1942C31.5375 18.937 31.05 18.79 30.4125 18.79C29.9625 18.79 29.5875 18.9003 29.2875 19.1207C28.9875 19.3044 28.8375 19.5617 28.8375 19.8924Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 15.8871L35.2875 24.2284H34.1625L35.55 21.3255L33.1125 15.9239H34.3125L36.075 20.0761H36.1125L37.8375 15.9239H39V15.8871Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7125 17.5039C18.7125 17.1732 18.675 16.8425 18.6375 16.5118H13.95V18.3858H16.6125C16.5 18.9738 16.1625 19.5249 15.6375 19.8556V21.0682H17.25C18.1875 20.2231 18.7125 18.9738 18.7125 17.5039Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9499 22.2441C15.2999 22.2441 16.4249 21.8032 17.2499 21.0683L15.6374 19.8557C15.1874 20.1496 14.6249 20.3333 13.9499 20.3333C12.6749 20.3333 11.5499 19.4882 11.1749 18.3123H9.5249V19.5617C10.3874 21.2152 12.0749 22.2441 13.9499 22.2441Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1751 18.3123C10.9501 17.7244 10.9501 17.063 11.1751 16.4383V15.189H9.5251C8.8126 16.5485 8.8126 18.1653 9.5251 19.5617L11.1751 18.3123Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.95 14.4541C14.6625 14.4541 15.3375 14.7113 15.8625 15.189L17.2875 13.7926C16.3875 12.9842 15.1875 12.5066 13.9875 12.5433C12.1125 12.5433 10.3875 13.5722 9.5625 15.2257L11.2125 16.4751C11.55 15.2992 12.675 14.4541 13.95 14.4541Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_591_2454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 14,
    fill: "white",
    transform: "translate(9 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.e734eff142ed2bc774ee3e3b374bb884.svg";
export { ForwardRef as ReactComponent };